import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="site-tasks--default-qty"
export default class extends Controller {
  static targets = ['rateUnit', 'quantity', 'calculatorButton']

  connect() {
  }

  changeRateUnit() {
    const isPricePerPiece = ['fixed_price', 'number'].includes(this.rateUnitTarget.value)
    if (isPricePerPiece && this.quantityTarget.value <= 0) {
      this.quantityTarget.value = 1
    }
    if (this.hasCalculatorButtonTarget) {
      const baseUrl = this.calculatorButtonTarget.getAttribute('data-measurement-url').split('?')[0]
      const params = new URLSearchParams(this.calculatorButtonTarget.getAttribute('data-measurement-url').split('?')[1] || '')
      params.set('rate_unit', this.rateUnitTarget.value)
      this.calculatorButtonTarget.setAttribute('data-measurement-url', `${baseUrl}?${params.toString()}`)
    }
  }

  openMeasurementModal(event) {
    event.preventDefault()
    const baseUrl = new URL(this.calculatorButtonTarget.getAttribute('data-measurement-url'), window.location.origin)
    baseUrl.searchParams.set('total', this.quantityTarget.value)
    const urlWithTotal = baseUrl.toString()
    fetch(urlWithTotal, { headers: { Accept: 'text/vnd.turbo-stream.html' } })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
  }
}
